import { useCallback } from "react";
import Dropzone from "../Dropzone";
import { router } from "@inertiajs/react";
import api from "@/api";

const ACCPET = {
  "text/plain": [".txt"],
  "application/pdf": [".pdf"],
  "application/zip": [".zip"],
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document": [".docx"],
};

export default function Uploader({ isOpen, onClose }) {
  if (!isOpen) return null;

  const onUploaded = useCallback((blobs) => {
    const blob = blobs[0];
    router.post(api.candidates.import.path(), { blob_signed_id: blob.signed_id });
    alert("上传成功，异步处理中，请稍后刷新查看结果。");
    onClose();
  }, [onClose, router.post, api.candidates.import.path()]);

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 max-w-2xl w-full">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-xl font-bold">批量导入简历</h3>
          <button
            className="text-gray-400 hover:text-gray-500"
            onClick={onClose}
          >
            <svg
              className="h-5 w-5"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth={2}
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>

        <div className="mb-4">
          <p className="text-gray-600 mb-4">
            请选择要批量导入的PDF简历文件。系统将自动解析每个文件并提取关键信息。
          </p>

          <Dropzone
            accept={ACCPET}
            onUploaded={onUploaded}
            label="上传职位描述文件"
            helpText="支持 TXT, ZIP, PDF, DOCX 格式"
          />
        </div>

        <div className="flex justify-end space-x-3 mt-4">
          <button
            className="px-4 py-2 border rounded text-gray-700 hover:bg-gray-50"
            onClick={onClose}
          >
            取消
          </button>
        </div>
      </div>
    </div>
  );
}
